<template>
	<aside class="main" :class="{'visible': ready}">
		<div v-if="ready" class="content">
			<img class="icon" alt="marker" src="images/map-marker-orange.svg"/>
			<label class="static">Your Local Office</label>
			<a class="name" @click="goToClinicPage" href="javascript:;">{{ clinic.name }}</a>
			<label class="address">{{  clinic.address }}</label>
			<label class="address">{{ clinic.city }}, {{clinic.state }} {{ clinic.zipCode }}</label>
			<a class="phone" :href="`tel:${helpers().callCenterPhoneNumber()}`" target="_top">{{ helpers().callCenterPhoneNumber() }}</a>
		</div>
	</aside>
</template>

<script>
	import { mapState, mapActions, mapMutations } from 'vuex';
	import Services from '../mixins/services';

	export default {
		mixins: [Services],
		components: {
		},
		data: function () {
			return {
				ready: false
			}
		},
        computed: mapState({
			clinic: state => state.LocalOfficeInfo.clinic,
			geoLocation: state => state.LocalOfficeInfo.geoLocation,
			clientToken: state => state.ClientToken.clientToken
		}),
		methods: {
			...mapActions('GoogleApi', { getIpLocation: 'getIpLocation' }),
			...mapActions('ClientToken', { getClientToken: 'getClientToken' }),
			...mapActions('LocalOfficeInfo', { updateGeoLocation: 'updateGeoLocation' }),
			...mapActions('LocalOfficeInfo', { getClinicInformation: 'getClinicInformation' }),
			setGeolocation(longitude, latitude) {
				this.updateGeoLocation({
					longitude: longitude,
					latitude: latitude,
				})
				this.getClinicInformation({
					Longitude: longitude,
					Latitude: latitude,
					ClientToken: this.clientToken,
					cb: () => {
						this.ready = true;
					}
				})
            },
            goToClinicPage() {
                window.top.location.href = `${document.referrer}${this.clinic.clinicUrl.substring(1)}`;
            }
		},
		mounted() {
			this.getClientToken({
				cb: () => {
					let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
					if (isSafari) {
						this.getIpLocation({
							cb: (res) => {
								this.setGeolocation(res.lng, res.lat);
							}
						})
					} else {
                        this.getIpLocation({
                            cb: (res) => {
                                this.setGeolocation(res.lng, res.lat);
                            }
                        });
                        navigator.geolocation.getCurrentPosition((position) => {
                            this.setGeolocation(position.coords.longitude, position.coords.latitude);
                        });
					}
				}
			});
		},
		created() {
			document.getElementsByTagName("body")[0].style.background = 'transparent';
		}
    }
</script>